import React, { useState } from "react";
import PopupBase from "../../../../../popup/base/PopupBase";
import CustomButton from "../../../../../components/buttons/CustomButton";
import { TextField, Select, MenuItem, FormControl, InputLabel, FormControlLabel, Switch, FormHelperText } from "@mui/material";

/** Texto do uso da categoria no popup de edição (por que não dá para excluir). */
const usageHint = (count) => (count === 1
  ? "Já tem 1 lançamento, por isso não pode ser excluída. Para tirá-la das listas sem perder o histórico, inative."
  : `Já tem ${count} lançamentos, por isso não pode ser excluída. Para tirá-la das listas sem perder o histórico, inative.`);

export function CreateEditCategoryPopup(props) {
  const { category, onClose, onSave } = props;

  const initialData = {
    id: category?.id || null,
    name: category?.name || "",
    type: category?.type || "income",
    // O banco devolve 1/0; o Switch precisa de booleano desde o primeiro render
    isActive: category ? !!Number(category.isActive) : true
  };

  const [categoryData, setCategoryData] = useState(initialData);
  const [nameError, setNameError] = useState("");
  const usageCount = Number(category?.usageCount) || 0;

  const handleChange = (field, value) => {
    if (field === "name" && value.trim()) setNameError("");
    setCategoryData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    if (!categoryData.name.trim()) {
      setNameError("Informe o nome");
      return;
    }

    onSave(categoryData);
  };

  const getFooter = () => (
    <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", width: "100%" }}>
      <CustomButton
        variant="outlined"
        style="primary"
        label="Cancelar"
        onClick={onClose}
      />
      <CustomButton
        variant="contained"
        style="main"
        label={category ? "Salvar Alterações" : "Adicionar"}
        onClick={handleSave}
      />
    </div>
  );

  const getContent = () => (
    <div style={{ marginTop: "var(--spacing-sm)" }}>
      <div className="form">
        <div style={{ display: "flex", gap: "var(--spacing-md)", flexDirection: "column" }}>
          {/* Nome */}
          <div className="form-group">
            <TextField
              fullWidth
              required
              label="Nome"
              value={categoryData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              error={!!nameError}
              helperText={nameError}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '40px',
                  borderRadius: 'var(--border-radius-sm)'
                }
              }}
            />
          </div>

          {/* Tipo */}
          <div className="form-group">
            <FormControl fullWidth>
              <InputLabel>Tipo</InputLabel>
              <Select
                value={categoryData.type}
                label="Tipo"
                onChange={(e) => handleChange("type", e.target.value)}
                disabled={!!category} // Não permite alterar o tipo ao editar
                sx={{
                  height: '40px',
                  borderRadius: 'var(--border-radius-sm)'
                }}
              >
                <MenuItem value="income">Receita</MenuItem>
                <MenuItem value="expense">Despesa</MenuItem>
              </Select>
              {category && <FormHelperText>O tipo fica fixo depois que a categoria é criada.</FormHelperText>}
            </FormControl>
          </div>

          {/* Status */}
          {category && (
            <FormControl>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!categoryData.isActive}
                    onChange={(e) => handleChange("isActive", e.target.checked)}
                  />
                }
                label={categoryData.isActive ? "Ativo" : "Inativo"}
              />
              {usageCount > 0 && <FormHelperText>{usageHint(usageCount)}</FormHelperText>}
            </FormControl>
          )}
        </div>
      </div>
    </div>
  );

  const getTitle = () => (category ? "Editar Categoria" : "Nova Categoria");

  return (
    <PopupBase
      Title={getTitle()}
      Content={getContent()}
      Footer={getFooter()}
      OnClose={onClose}
      maxWidth="xs"
    />
  );
}
